module.exports = __webpack_public_path__ + "img/logoUlip100x100.0ad7fd82.svg";